import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { hide } from '../../services/reducers/popupSlice';
import tools from '../../utils/tools';
import { AppDispatch } from '../../services/store';

const UNIT_LABELS: Record<string, string> = {
  box: 'کارتن قوطی',
  roll: 'کارتن رولی',
};

interface CommerceDetailsModalProps {
  product: any;
}

// "تعداد در حال فروش" used to be one opaque summed number with no way to see
// which pending orders/users it came from. This lists each pending order
// (WaitForCommerceBearingApproval / WaitForCommerceFeltBowlApproval /
// WaitForWarehouseApproval) holding stock of this product.
const CommerceDetailsModal = ({ product }: CommerceDetailsModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const close = () => dispatch(hide());
  const details = product.commerceDetails || [];

  return (
    <div className="modalContainer" style={{ width: 640, height: 'auto', position: 'static', margin: 0 }}>
      <div className="modalHeading">
        <h2>سفارش‌های در حال انتظار — {product.title} ({product.sku})</h2>
        <i className="modalExit clickable" onClick={close}></i>
      </div>

      <div className="cardex-table-container" style={{ maxHeight: 420, overflowY: 'auto' }}>
        <table className="cardex-table">
          <thead>
          <tr className="cardex-table-header">
            <th>شماره سفارش</th>
            <th>مشتری</th>
            <th>نوع</th>
            <th>تعداد × واحد</th>
            <th>مجموع عدد</th>
          </tr>
          </thead>
          <tbody>
          {details.map((d: any, i: number) => (
            <tr className="cardex-row" key={i}>
              <td className="cardex-cell">
                <Link to={`/order/edit/${d.orderId}`} target="_blank">{d.orderCode || d.orderId}</Link>
              </td>
              <td className="cardex-cell">{d.userName || '—'}</td>
              <td className="cardex-cell">{UNIT_LABELS[d.unitType] || d.unitType}</td>
              <td className="cardex-cell">{d.count} × {d.itemsPerUnitType ?? '—'}</td>
              <td className="cardex-cell">{tools.formatPrice(d.items)}</td>
            </tr>
          ))}
          {details.length === 0 && (
            <tr><td className="cardex-cell" colSpan={5}>در حال حاضر سفارش بازی برای این محصول وجود ندارد</td></tr>
          )}
          </tbody>
        </table>
      </div>

      <div className="modalBtns">
        <span className="cancel clickable" onClick={close}>بستن</span>
      </div>
    </div>
  );
};

export default CommerceDetailsModal;
